/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'

import colors from '../../../../../assets/colors'
import {
  showNfseConfig,
  showNfsenConfig,
  storeNfseConfig,
  storeNfsenConfig,
  indexNfsenEnquadramento,
  storeNfsenEnquadramento,
  updateNfsenEnquadramento,
  destroyNfsenEnquadramento,
} from '../../../LaundryEletronicInvoiceActions'
import { CustomSwitch } from '../../../../../components/ui/custom-switch'
import Enquadramentos from '../Enquadramentos'
import { NFSEN_ENQUADRAMENTO_FIELDS } from '../Enquadramentos/fields'

const useStyles = makeStyles({
  box: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  subTitle: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  btnSave: {
    borderRadius: '20px',
    color: '#FFF',
    backgroundColor: colors.primary,
    fontSize: '12px',
    textTransform: 'capitalize',
    width: '101px',
    padding: '4px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: '.7',
    },
  },
})

const NfsenConfig = ({
  active = false,
  handleChangeEletronicInvoiceNational = active => {},
}) => {
  const dispatch = useDispatch()

  const nfsenConfig = useSelector(
    state => state.laundryEletronicInvoice.nfsen_config
  )

  const classes = useStyles()

  const [form, setForm] = useState({
    codigo_opcao_simples_nacional: '',
    regime_tributario_simples_nacional: '',
    regime_especial_tributacao: '',
    envio_inscricao_municipal: 1,
  })

  const handleSubmit = e => {
    e.preventDefault()

    const data = new FormData(e.target)
    data.append(
      'envio_inscricao_municipal',
      Number(form?.envio_inscricao_municipal) || 0
    )
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    try {
      const resp = dispatch(storeNfsenConfig(values))
    } catch (e) {
      console.log(e)
    }
  }

  const initForm = () => {
    setForm({
      ...form,
      ...nfsenConfig,
    })
  }

  useEffect(() => {
    dispatch(showNfsenConfig())
  }, [])

  useEffect(() => {
    initForm()
  }, [nfsenConfig])

  return (
    <Grid container xs={12}>
      <Grid item xs={12} className={classes.box}>
        <Box className={classes.subTitle}>
          O Ambiente Nacional da NFS-e é a iniciativa do Governo Federal para
          padronizar a emissão de Notas Fiscais de Serviço Eletrônicas em um
          único layout e fluxo, substituindo gradualmente os emissores
          municipais individuais.
        </Box>

        <form onSubmit={handleSubmit} hidden={!active}>
          <Grid container spacing={4}>
            <Grid item md={3} xs={12}>
              <TextField
                key={`codigo_opcao_simples_nacional-${nfsenConfig?.codigo_opcao_simples_nacional}`}
                select
                name="codigo_opcao_simples_nacional"
                fullWidth
                label="Situação perante Simples Nacional"
                defaultValue={nfsenConfig?.codigo_opcao_simples_nacional}
                required
              >
                <MenuItem value="">Selecione...</MenuItem>
                <MenuItem value="1">Não Optante</MenuItem>
                <MenuItem value="2">
                  Optante - Microempreendedor Individual (MEI)
                </MenuItem>
                <MenuItem value="3">
                  Optante - Microempresa ou Empresa de Pequeno Porte (ME/EPP)
                </MenuItem>
              </TextField>
            </Grid>

            <Grid item md={5} xs={12}>
              <TextField
                key={`regime_tributario_simples_nacional-${nfsenConfig?.regime_tributario_simples_nacional}`}
                select
                name="regime_tributario_simples_nacional"
                fullWidth
                label="Regime de Apuração Tributária pelo Simples Nacional"
                defaultValue={nfsenConfig?.regime_tributario_simples_nacional}
              >
                <MenuItem value="">Selecione...</MenuItem>
                <MenuItem value="1">
                  Regime de apuração dos tributos federais e municipal pelo SN.
                </MenuItem>
                <MenuItem value="2">
                  Regime de apuração dos tributos federais pelo SN e o ISSQN
                  pela NFS-e conforme respectiva legislação municipal do
                  tributo;
                </MenuItem>
                <MenuItem value="3">
                  Regime de apuração dos tributos federais e municipal pela
                  NFS-e conforme respectivas legilações federal e municipal de
                  cada tributo.
                </MenuItem>
              </TextField>
            </Grid>

            <Grid item md={5} xs={12}>
              <TextField
                key={`regime_especial_tributacao-${nfsenConfig?.regime_especial_tributacao}`}
                select
                name="regime_especial_tributacao"
                fullWidth
                label="Tipos de Regimes Especiais de Tributação Municipal:"
                defaultValue={nfsenConfig?.regime_especial_tributacao}
                required
              >
                <MenuItem value="">Selecione...</MenuItem>
                <MenuItem value="0">Nenhum</MenuItem>
                <MenuItem value="1">Ato Cooperado (Cooperativa)</MenuItem>
                <MenuItem value="2">Estimativa</MenuItem>
                <MenuItem value="3">Microempresa Municipal</MenuItem>
                <MenuItem value="4">Notário ou Registrador</MenuItem>
                <MenuItem value="5">Profissional Autônomo</MenuItem>
                <MenuItem value="6">Sociedade de Profissionais</MenuItem>
                <MenuItem value="9">Outros</MenuItem>
              </TextField>
            </Grid>

            <Grid item md={3} xs={3}>
              <Grid
                container
                style={{ height: '100%' }}
                justifyContent="flex-start"
                alignItems="flex-end"
                spacing={1}
              >
                <Grid item>Enviar inscrição municipal:</Grid>
                <Grid item>
                  <CustomSwitch
                    checked={form?.envio_inscricao_municipal}
                    onClick={() =>
                      setForm({
                        ...form,
                        envio_inscricao_municipal:
                          !form?.envio_inscricao_municipal,
                      })
                    }
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item md xs>
              <Grid
                container
                style={{ height: '100%' }}
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Grid item>
                  <Button type="submit" className={classes.btnSave}>
                    Salvar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>

        <Enquadramentos
          title="Enquadramentos tributários (Nacional)"
          fields={NFSEN_ENQUADRAMENTO_FIELDS}
          indexFn={indexNfsenEnquadramento}
          storeFn={storeNfsenEnquadramento}
          updateFn={updateNfsenEnquadramento}
          destroyFn={destroyNfsenEnquadramento}
        />
      </Grid>
    </Grid>
  )
}

export default NfsenConfig
